export default "__VITE_ASSET__bb45e843__"